import { useContext } from 'react'
import {Link} from 'react-router-dom'
import { UserContext } from '../../Routes/Routes1'
import './side-navbar.css'

export default function SideNavbar(){
    const {state}=useContext(UserContext)

    function openNav(){
        document.getElementById('mySidenav').style.width='44.5vh'
    }
    function closeNav(){
        document.getElementById('mySidenav').style.width='0'
    }

    return(
        <>
        <div className="navBody">
            <div id="mySidenav" className="sidenav">
                <Link to="#" className="closebtn" onClick={closeNav}>&times;</Link>
                <Link to="/" className="link">Home</Link>
                <Link to={state?"profile":'/login'} className="link">Profile</Link>
                <Link to={state?"play_list":'/login'} className="link">Play List</Link>
                <Link to="new_song" className="link">New Songs</Link>
                <Link to="old_song" className="link">Old Songs</Link>
            </div>
            
        </div>
        
            <span style={{fontSize:'25px',cursor:'pointer'}} onClick={openNav}>&#9776;</span>
        
        </>
    )
}

// onClick="openNav()"   onClick="closeNav()"